/**
 * Rodapé: revela o conteúdo quando a página lá chega.
 *
 * A onda anda sozinha em CSS; isto trata só da entrada. Sem o observador, a
 * animação corria ao carregar a página — e o rodapé está sempre fora do ecrã
 * nessa altura, por isso ninguém a via.
 */
class ClaroRodape extends HTMLElement {
  connectedCallback() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('claro-rodape--vis');
      return;
    }

    const observador = new IntersectionObserver(
      ([entrada]) => {
        if (!entrada.isIntersecting) return;
        this.classList.add('claro-rodape--vis');
        observador.disconnect(); // entra uma vez; não é um efeito de repetição
      },
      { threshold: 0.15 }
    );
    observador.observe(this);
  }
}

if (!customElements.get('claro-rodape')) customElements.define('claro-rodape', ClaroRodape);
